<template>
  <dialog ref="modal" class="modal">
    <div class="modal-box max-h-[calc(100vh-4rem)]">
      <form method="dialog">
        <button class="btn btn-sm btn-circle btn-ghost absolute top-2 right-2">
          ✕
        </button>
      </form>
      <h3 class="text-lg font-bold">Yêu cầu cập nhật cho chiến dịch</h3>
      <div class="py-4">
        <div v-if="isLoadingVersions">Đang tải...</div>
        <div v-else>
          <div v-if="versions.length === 0">
            Không có phiên bản nào khả dụng.
          </div>
          <div v-else>
            <div
              class="max-h-[calc(100vh-15rem)] overflow-x-auto overflow-y-auto"
            >
              <table class="table-pin-rows table">
                <thead>
                  <tr>
                    <th>STT</th>
                    <th>Tên phiên bản</th>
                    <th>Hành động</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(version, index) in versions" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ version.name }}</td>
                    <td>
                      <button
                        class="btn btn-primary btn-sm"
                        @click="selectVersion(version)"
                      >
                        Chọn
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import {
  getVersionAgentPagination,
  type VersionAgentItem,
} from "@/api/campaign";
import { useCreateUpdateCommandMutation } from "@/api/updateHistory";
import { useQuery, useQueryClient } from "@tanstack/vue-query";
import { computed, ref } from "vue";

const props = defineProps<{
  campaignId: string;
}>();

const modal = ref<HTMLDialogElement | null>(null);

const { data: versionsData, isFetching: isLoadingVersions } = useQuery({
  queryKey: computed(() => ["availableCampaignVersions", props.campaignId]),
  queryFn: () =>
    getVersionAgentPagination({
      page: 1,
      size: 10,
      campaign: props.campaignId,
    }),
  enabled: computed(() => Boolean(props.campaignId)),
});

const versions = computed<VersionAgentItem[]>(
  () => versionsData.value?.data || [],
);

const queryClient = useQueryClient();

const { mutateAsync: createUpdateCommand } = useCreateUpdateCommandMutation();

const selectVersion = async (version: VersionAgentItem) => {
  try {
    await createUpdateCommand({
      agent_id: "",
      campaign_id: props.campaignId,
      version_id: version.id,
    });

    queryClient.invalidateQueries({ queryKey: ["updateHistory"] });
    queryClient.invalidateQueries({
      queryKey: ["availableCampaignVersions", props.campaignId],
    });

    modal.value?.close();
  } catch (err) {
    console.error("Failed to create update command", err);
  }
};

defineExpose({
  modal,
});
</script>
